/* unplugin-vue-components disabled */import { render } from "./upload-item.vue?vue&type=template&id=38f695df&scoped=true"
import script from "./upload-item.vue?vue&type=script&lang=js"
export * from "./upload-item.vue?vue&type=script&lang=js"

import "./upload-item.vue?vue&type=style&index=0&id=38f695df&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f695df"],['__file',"src/controls/upload-item.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38f695df"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38f695df', __exports__)) {
    api.reload('38f695df', __exports__)
  }
  
  module.hot.accept("./upload-item.vue?vue&type=template&id=38f695df&scoped=true", () => {
    api.rerender('38f695df', render)
  })

}


export default __exports__